import { render, staticRenderFns } from "./searchNews.vue?vue&type=template&id=7a2be81b&scoped=true&"
import script from "./searchNews.vue?vue&type=script&lang=js&"
export * from "./searchNews.vue?vue&type=script&lang=js&"
import style0 from "./searchNews.vue?vue&type=style&index=0&id=7a2be81b&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2be81b",
  null
  
)

export default component.exports